module.exports = __webpack_public_path__ + "img/hit.58db8e00.jpg";